import type { IntlShape, MessageDescriptor } from 'react-intl-next';

import { contentKeywordMessages, titleKeywordMessages } from './messages.ts';

const materialize = (intl: IntlShape, messages: Record<string, MessageDescriptor>): string[] =>
	Object.values(messages).reduce<string[]>((keywords, descriptor) => {
		const keyword = intl.formatMessage(descriptor);
		if (keyword.trim().length > 0) {
			keywords.push(keyword);
		}
		return keywords;
	}, []);

/**
 * Resolves the (localized) title keyword list for the current locale. Seeded in
 * English; falls back to `defaultMessage` when a locale has no translation.
 */
export const getTitleKeywords = (intl: IntlShape): string[] =>
	materialize(intl, titleKeywordMessages);

/** Resolves the (localized) content keyword list for the current locale. */
export const getContentKeywords = (intl: IntlShape): string[] =>
	materialize(intl, contentKeywordMessages);
